import React from 'react'
import styles from './ContentOpenNav.less'
import { sh, ReduxWrapper, compose, buildPropTypes, pt } from 'common-data/datahelpers'
import { DataGridSearch } from 'common-controls/Core/index'

export class ContentOpenNavPlain extends React.Component {
  static propTypes = buildPropTypes([
  ], {
    navs: pt.arrayOf(pt.shape({
      text: pt.string,
      link: pt.string
    }))
  })

  render () {
    const { LayoutContentSearch, CurrentRouteInfo } = this.props

    const currentSearh = LayoutContentSearch.get(CurrentRouteInfo.pathname)

    if (!currentSearh) {
      return null
    }

    return (
      <div className={styles.root}>
        <DataGridSearch formName={currentSearh.formName} fieldName={currentSearh.fieldName} icon={currentSearh.icon || 'search'} promptText={currentSearh.promptText} onSubmit={currentSearh.onSubmit} />
      </div>
    )
  }
}

export const ContentOpenNav = compose(
  ReduxWrapper([
    sh.LayoutContentSearch,
    sh.CurrentRouteInfo,
    sh.SessionAccount,
    sh.SessionUser
  ])
)(ContentOpenNavPlain)
